export enum TransportEnum {
    Personal = "Personal",
    Company = "Company"
  }